// removed by extract-text-webpack-plugin
module.exports = {"root":"root_xNd6e","form":"form_Me20M"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PageCgn/style.css
// module id = 229
// module chunks = 0